import { render } from "./ViewReprocessedTransactions.vue?vue&type=template&id=6a5ad469"
import script from "./ViewReprocessedTransactions.vue?vue&type=script&lang=js"
export * from "./ViewReprocessedTransactions.vue?vue&type=script&lang=js"

import "./ViewReprocessedTransactions.vue?vue&type=style&index=0&id=6a5ad469&lang=css"

import exportComponent from "C:\\Users\\AbdullahiIsmail\\OneDrive - SWWIPE FINACIAL SERVICES\\Documents\\Automation-tool\\auto-portalV2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__